import { Sheet, SheetContent } from "@/components/ui/sheet";
import { ModalHeader } from "@/components/shared/ModalHeader";
import { SheetTitle } from "@/components/ui/sheet";
import { cn } from "@/lib/utils";

type CustomSheetProps = {
  children: React.ReactNode;
  open: boolean;
  onOpenChange: (value: boolean) => void;
  title: string;
  description?: string;
  headerStart?: React.ReactNode;
  className?: string;
  bodyClassName?: string;
  hideHeader?: boolean;
};

const CustomSheet = ({
  children,
  open,
  onOpenChange,
  title,
  description,
  headerStart,
  className,
  bodyClassName,
  hideHeader = false,
}: CustomSheetProps) => {
  const headerContent = hideHeader ? (
    <SheetTitle className="sr-only">{title}</SheetTitle>
  ) : (
    <ModalHeader
      title={title}
      description={description}
      headerStart={headerStart}
      isSheet={true}
    />
  );

  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetContent
        hideClose={true}
        onEscapeKeyDown={(e) => e.preventDefault()}
        onOpenAutoFocus={(e) => e.preventDefault()}
        side="bottom"
        className={cn(
          "flex max-h-[calc(100dvh-96px)] flex-col overflow-hidden rounded-t-4xl border-0 bg-white p-0 md:hidden",
          className,
        )}
      >
        <div className="flex min-h-0 flex-1 flex-col">
          {headerContent}

          <div
            className={cn(
              "min-h-0 flex-1 overflow-x-hidden overflow-y-auto",
              bodyClassName,
            )}
          >
            {children}
          </div>
        </div>
      </SheetContent>
    </Sheet>
  );
};

export default CustomSheet;
